import React, { Suspense } from 'react';
import { render } from 'react-dom';
import Pagination from 'react-paginating';
import Footer from './Footer';
import $ from 'jquery';
import { backgroundImage } from './common';
import { withRouter } from "react-router-dom";
import Product from './Product';
import { createBrowserHistory } from 'history';
import { useImage } from 'react-image'
import { get_json, imagePath } from './common';
import { connect } from 'react-redux';
import ErrorBoundary from './Component/ErrorBoundary'
const history = createBrowserHistory();
function ProductComponent(props) {
  const { src, error } = useImage({
    srcList: props.image
  })

  return (
    <img src={src}></img>
  )
}
function BgComponent(props) {
  const { src } = useImage({
    srcList: require('./images/newsletter.jpg')
  })
  return (
    <div className="headerImage" style={{ backgroundImage: 'url("' + src + '")', backgroundSize: 'cover', backgroundPosition: 'center bottom', backgroundRepeat: 'no-repeat', height: 250, position: 'relative' }}>
      <div className="center_text">
        <h3>{window.location.href.match(/([^\/]*)\/*$/)[1]}</h3>
      </div>
    </div>
  )
}

class Collection extends React.Component {
  constructor() {
    super();
    this.state = { subcollection_type: [] };
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    if (this.props.alldata === null) {
      await get_json(this)
      this.props.setresponseJson(this.state.data)
      await this.filter_data()
    } else {
      await this.setState({ data: this.props.alldata })
      await this.filter_data()
    }
  }

  async filter_data() {
    var title = window.location.href.match(/([^\/]*)\/*$/)[1];
    let collection_type = [];
    let subcollection_type = [];
    let subcollection_item = [];
    let all_collection = this.state.data.all_collection;
    console.log(all_collection, "all_collection")
    if (typeof all_collection !== 'undefined') {
      if (all_collection.length > 0) {
        all_collection.forEach(async (item, i) => {
          if (item.collection_type === title) {
            let x = collection_type.filter((a) => { if (a.subcollection_type == item.subcollection_type) { return a } });
            if (x.length < 2) {
              if (subcollection_type.indexOf(item.subcollection_type) == -1) {
                subcollection_type.push(item.subcollection_type)
                subcollection_item.push(item)
              }
              collection_type.push(item);
            }
          }
        });
      }
    }
    await this.setState({ collection_type: collection_type, subcollection_type: subcollection_item, currency_code: this.state.data.currency_code,currency_symbol:this.state.data.currency_symbol });
    console.log(collection_type, "subcollection_item", subcollection_item)
  }

  redirect_page(subcollection_type, collection_type) {

    this.props.history.push({ pathname: "/" + collection_type + "/" + subcollection_type, state: { subcollection_type: subcollection_type, collection_type: collection_type } });
  }
  redirect_page_product(product_image, product_name, product_information, product_price, product_code, product_brand, subcollection_type, collection_type) {

    this.props.history.push({ pathname: "/" + collection_type + "/" + subcollection_type + "/product/" + product_code, state: { subcollection_type: subcollection_type, collection_type: collection_type, product_image: product_image, product_name: product_name, product_information: product_information, product_price: product_price, product_code: product_code, product_brand: product_brand ,currency_code:this.state.currency_code,currency_symbol:this.state.currency_symbol} });
  }

  render() {
    let collection_type = this.state.collection_type;

    let subcollection_type = this.state.subcollection_type
    return (
      <div className="middleContent main_contact">
        {/* {<Suspense fallback={<div className="headerImage" style={{ height: 250, position: 'relative' }}>
          <div class="place_effect showed">
            <div class="img_div"></div>
          </div>
        </div>}>
          <BgComponent></BgComponent>
        </Suspense>} */}
        <div className="colle-pad container">
          <div className="center_text">
            <h3>{window.location.href.match(/([^\/]*)\/*$/)[1]}</h3>
          </div>
        </div>
        <div className="collec-main-box">
          {subcollection_type.length === 0 && <div><h1 style={{ textAlign: 'center' }}>No record found</h1><br></br></div>}
          {(collection_type !== undefined && collection_type.length > 0 && collection_type !== null) &&
            subcollection_type.map((a, index) => {
              let x = collection_type.filter((c) => { if (c.subcollection_type == a.subcollection_type) { return c } })

              return (

                <div className="collec-main-sec" key={index}>
                  <div className="collecSec">
                    <div className="container">
                      <div className="collecWrapper">
                        <div className="colleItem">
                          <div className="row collecRow">
                            <div className="collecColumn col-12 col-md-6">
                              <div className="collecImage">
                                <div className="imageGrowWithScaleLeft">
                                 
                                    <Suspense fallback={<div></div>}>
                                      <ProductComponent image={imagePath + a.subcollection_image} className="attachment-full" alt></ProductComponent>
                                    </Suspense>
                                 
                                </div>
                              </div>
                            </div>
                            <div className="collecColumn col-12 col-md-6">
                              <h4>{a.subcollection_type} ({a.collection_type})</h4>
                              <div className="row">

                                {
                                  x.map((item,i) => (
                                    <div className="colle_wrap_item collection-div col-12 col-sm-6" key={i}>
                                      <a onClick={() => this.redirect_page_product(item.product_image, item.product_name, item.product_information, item.product_price, item.product_code, item.product_brand, a.subcollection_type, a.collection_type)}>
                                        <div className="img-div-gallery">

                                          {(item.product_image) &&

                                            <ErrorBoundary><Suspense fallback={<div class="place_effect showed">
                                              <div className="img_div"></div>
                                            </div>}>
                                              <ProductComponent image={imagePath + ((item.product_image.split(','))[0])}></ProductComponent>
                                            </Suspense></ErrorBoundary>}
                                        </div>
                                        <div className="all_collection-div">
                                          <div className="collection-detail-div">
                                            <h2 className="collection-title-div">{item.product_name}</h2>
                                            {/* {<p className="collection-description-div">{item.product_information}</p>} */}
                                          </div>
                                          <div className="deatils-pos-rel"><span className="collection-span">{this.state.currency_symbol}: {this.state.currency_code==="EUR" ?(item.product_price*0.012).toFixed(3): this.state.currency_code==="USD" ?(item.product_price*0.014).toFixed(3):this.state.currency_code==="AED"?(item.product_price*0.051).toFixed(3):item.product_price}</span>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  ))
                                }

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="view_all">
                    <a href="Javascript:void(0)" className="hvr-outline-out button2" onClick={() => this.redirect_page(a.subcollection_type, a.collection_type)}>View All</a>
                  </div>
                </div>
              )
            })
          }


        </div>
        <Footer />
      </div>



    );
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    alldata: state.responseJson,

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Collection);


